(function () {
function initLazyVideos(scope) {
    var root = scope || document;
    var items = root.querySelectorAll('[data-video-lazy]');
    if (!items.length) return;

    items.forEach(function (wrap) {
    if (wrap.__videoBound) return;
    wrap.__videoBound = true;

    var btn = wrap.querySelector('.slide-video-lazy__play');
    var poster = wrap.querySelector('.slide-video-lazy__poster');
    var src = wrap.getAttribute('data-video-src');
    var controls = wrap.getAttribute('data-video-controls') === 'true';

    if (!src || !btn || !poster) return;

    function loadVideo() {
        if (wrap.__videoLoaded) return;
        wrap.__videoLoaded = true;

        var video = document.createElement('video');
        video.className = 'slide-video';
        video.playsInline = true;
        video.muted = true;
        video.autoplay = true;
        video.loop = wrap.getAttribute('data-video-loop') === 'true';
        video.preload = 'metadata';
        if (controls) video.controls = true;

        var source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.appendChild(source);

        // Replace poster with video
        wrap.innerHTML = '';
        wrap.appendChild(video);

        // Toggle play/pause on click if controls are hidden
        video.addEventListener('click', function () {
        // ako postoje kontrole, neka browser radi svoje (ne diramo)
        if (controls) return;

        if (video.paused) {
            var pp = video.play();
            if (pp && typeof pp.catch === 'function') pp.catch(function(){});
        } else {
            video.pause();
        }
        }, { passive: true });

        // Try play (mobile safeness)
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function(){});
    }

    btn.addEventListener('click', loadVideo, { passive: true });
    // Bonus: klik bilo gde na posteru
    poster.addEventListener('click', function (e) {
        // da ne duplira kad klikne baš dugme
        if (e.target === btn) return;
        loadVideo();
    }, { passive: true });
    });
}

// normal load
document.addEventListener('DOMContentLoaded', function () {
    initLazyVideos(document);
});

// ako theme ima dinamičko učitavanje sekcija (Shopify editor / AJAX)
document.addEventListener('shopify:section:load', function (e) {
    initLazyVideos(e.target);
});
})();